import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header__controls icon-toolbar" }

import { onBeforeMount, onBeforeUnmount, ref } from 'vue'

import BackLink from '@/app/components/BackLink.vue'
import DocLibraryMenu from '@/app/components/doc/DocLibraryMenu.vue'
import DocListsMenu from '@/app/components/doc/DocListsMenu.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'
import SaveButton from '@/app/components/doc/SaveButton.vue'
import IconButton from '@/app/components/button/IconButton.vue'
import ExportBookButton from '@/app/components/doc/preview/ExportBookButton.vue'
import { emitter } from '@/services/mitt'
import { saveForLater20321Treatment } from '@/services/ab/experiments'
import type { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderPreviewPage',
  props: {
    doc: {}
  },
  setup(__props: any) {



const showNewSaveDesign = saveForLater20321Treatment()

const isRounded = ref(false)

onBeforeMount(() => {
  emitter.on('appScroll', scrollHandler)
})

onBeforeUnmount(() => {
  emitter.off('appScroll')
})

function scrollHandler(): void {
  // Get current scrolling position
  const scrollTop = (document.getElementById('app') as HTMLElement).scrollTop

  // Get height of the book block - it's different on different widths
  const bookBlockHeight = (
    document.querySelector('.doc-preview__cover') as HTMLElement
  ).offsetHeight

  // Book block has roundings, and we need to apply rounding to the header
  // before it reaches the roundings of the book block.
  const maxScroll = bookBlockHeight - 8
  isRounded.value = scrollTop > maxScroll
}

return (_ctx: any,_cache: any) => {
  return (__props.doc)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["header header--book header--book-preview", { 'header--book-preview-rounded': isRounded.value }])
      }, [
        _createVNode(BackLink, { class: "header__backlink" }),
        _createElementVNode("div", _hoisted_1, [
          (_unref(showNewSaveDesign))
            ? (_openBlock(), _createBlock(SaveButton, {
                key: 0,
                class: "book-preview-save-btn icon-toolbar__item icon-toolbar__item--separator",
                doc: __props.doc
              }, {
                default: _withCtx(({ isBusy, icon, label }) => [
                  _createVNode(IconButton, {
                    icon: icon,
                    "aria-label": label,
                    disabled: isBusy,
                    outlined: ""
                  }, null, 8, ["icon", "aria-label", "disabled"])
                ]),
                _: 1
              }, 8, ["doc"]))
            : (_openBlock(), _createBlock(DocListsMenu, {
                key: 1,
                class: "book-preview-favorite-btn icon-toolbar__item icon-toolbar__item--separator",
                doc: __props.doc
              }, null, 8, ["doc"])),
          (__props.doc.showDownload)
            ? (_openBlock(), _createBlock(ExportBookButton, {
                key: 2,
                class: "book-preview-download-btn icon-toolbar__item icon-toolbar__item--separator",
                doc: __props.doc
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (_unref(showNewSaveDesign))
            ? (_openBlock(), _createBlock(DocMoreMenu, {
                key: 3,
                class: "book-preview-more-btn icon-toolbar__item icon-toolbar__item--separator",
                doc: __props.doc,
                hideDownload: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(IconButton, {
                    icon: "imore",
                    "aria-label": "More actions",
                    outlined: ""
                  })
                ]),
                _: 1
              }, 8, ["doc"]))
            : (_openBlock(), _createBlock(DocLibraryMenu, {
                key: 4,
                class: "book-preview-actions-btn icon-toolbar__item icon-toolbar__item--separator",
                doc: __props.doc,
                position: "right",
                markNotStarted20321B: _unref(saveForLater20321Treatment)()
              }, null, 8, ["doc", "markNotStarted20321B"]))
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})